export const resolvePrintCartCheckoutMetadata = (prints, cartLines) => {
  if (!Array.isArray(cartLines) || cartLines.length === 0) {
    return { ready: false, reason: 'empty-cart' };
  }
  if (!Array.isArray(prints)) {
    return { ready: false, reason: 'prints-loading' };
  }

  const matchedPrints = cartLines.map((line) => prints.find((print) => print.id === line.printId));
  if (matchedPrints.some((print) => !print)) {
    return { ready: false, reason: 'print-not-found' };
  }

  const firstLine = cartLines[0];
  const firstPrint = matchedPrints[0];
  if (!firstPrint.title) {
    return { ready: false, reason: 'print-title-missing' };
  }

  return {
    ready: true,
    params: {
      printId: firstLine.printId,
      printTitle: firstPrint.title,
      output: firstLine.fulfillmentKind === 'digital' ? 'pdf' : firstLine.binding,
      format: firstLine.format,
      type: firstLine.productType,
      pages: firstLine.totalPages,
      quantity: firstLine.quantity,
    },
  };
};
